import "./topBar.scss";

interface ITopBar {
  right: JSX.Element | undefined;
  left: JSX.Element | undefined;
}

export const TopBar = ({ right, left }: ITopBar) => {
  return (
    <>
      <div className="topBar">
        <div className="flex align-items-center ml-4">{left}</div>
        <div className="flex align-items-center mr-4">{right}</div>
      </div>
    </>
  );
};
